<template lang="html">
  <div>
    <br>

    <!-- Dialog de confirmação de envio do projeto de pesquisa para registro -->
    <c-confirm-dialog v-model="dialogConfirmaEnvioProjetoParaRegistro" @yes="enviarProjetoPesquisaParaRegistro()" titulo="Confirma o envio do projeto de pesquisa para registro?">
    </c-confirm-dialog>

    <v-layout align-center justify-center>
      <v-flex xs12 lg8>

        <!-- Contatos do coordenador -->
        <v-layout row wrap justify-space-between v-if="administradorPRPPG || projetoPesquisa.coordenador">
          <v-flex xs12>
            <div class="tituloSecao">
              <label>Contatos do coordenador</label>
            </div>
          </v-flex>
        </v-layout>

        <!-- E-mail -->
        <v-layout row v-if="administradorPRPPG || projetoPesquisa.coordenador"> 
          <v-flex xs12>
            <c-readonly-field 
            label="E-mail" 
            :value="this.projetoPesquisa.emailCoordenador ? this.projetoPesquisa.emailCoordenador : '-'" 
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Telefone -->
        <v-layout row v-if="administradorPRPPG || projetoPesquisa.coordenador">
          <v-flex xs12>
            <c-readonly-field 
            label="Telefone" 
            :value="this.projetoPesquisa.telefoneCoordenador ? this.projetoPesquisa.telefoneCoordenador : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Contatos do projeto de pesquisa -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <div class="tituloSecao">
              <label>Contatos do projeto de pesquisa</label>
            </div>
          </v-flex>
        </v-layout>

        <!-- Nome do contato -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Nome do contato" 
            :value="this.projetoPesquisa.nomeContato ? this.projetoPesquisa.nomeContato : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- E-mail -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="E-mail" 
            :value="this.projetoPesquisa.emailContato ? this.projetoPesquisa.emailContato : '-'" 
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Telefone -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Telefone" 
            :value="this.projetoPesquisa.telefoneContato ? this.projetoPesquisa.telefoneContato : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Site -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Site" 
            :value="this.projetoPesquisa.site ? this.projetoPesquisa.site : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Mídias sociais -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Mídias sociais" 
            :value="this.projetoPesquisa.midiasSociais ? this.projetoPesquisa.midiasSociais : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <br>

      </v-flex>  
    </v-layout>

    <v-divider></v-divider>

    <v-card-actions>

      <!-- Botão "Voltar" -->
      <v-btn color="primary" @click="toVoltar()">Voltar</v-btn>

      <!-- Botão "Enviar para registro" -->
      <v-btn v-if="habilitaBotaoEnviarParaRegistro()" color="primary" @click="toEnviarParaRegistro()">Enviar para registro</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Editar" -->
      <v-btn color="primary" @click="toEditar()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Editar</v-btn>

      <!-- Botão "Avançar" -->
      <v-btn v-if="habilitaBotaoAvancar()" color="primary" @click="toAvancar()">Avançar</v-btn>

    </v-card-actions>
    
  </div>
</template>

<script>
import projetos from '@/utils/projetos'
import ConfirmDialog from '@/components/c-confirm-dialog'
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
    dialogConfirmaEnvioProjetoParaRegistro: false
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Verifica se o projeto de pesquisa está na situação "Em preenchimento".
    situacaoEmPreenchimento: function () {
      if (this.projetoPesquisa.situacao.item === 1) {
        return true
      } else {
        return false
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Em andamento".
    situacaoEmAndamento: function () {
      if (this.projetoPesquisa.situacao.item === 3) {
        return true
      } else {
        return false
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Concluído".
    situacaoConcluido: function () {
      if (this.projetoPesquisa.situacao.item === 4) {
        return true
      } else {
        return false
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Cancelado".
    situacaoCancelado: function () {
      if (this.projetoPesquisa.situacao.item === 5) {
        return true
      } else {
        return false
      }
    },

    // Habilita botão "Avançar".
    habilitaBotaoAvancar: function () {
      if (this.situacaoEmAndamento() || this.situacaoConcluido() || this.situacaoCancelado()) {
        return true
      } else {
        return false
      }
    },

    // Habilita botão "Enviar para registro".
    habilitaBotaoEnviarParaRegistro: function () {
      if (this.situacaoEmPreenchimento()) {
        return true
      } else {
        return false
      }
    },

    // Envia o projeto de pesquisa para registro (abre dialog de confirmação).
    toEnviarParaRegistro: function () {
      this.dialogConfirmaEnvioProjetoParaRegistro = true
    },

    // Edita a aba "Contatos".
    toEditar: function () {
      this.$router.push({ name: 'EditarProjetoPesquisaContatos', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Voltar para a aba anterior.
    toVoltar: function () {
      this.$router.push({ name: 'ProjetoPesquisaOutrasInformacoes', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Avançar para a próxima aba.
    toAvancar: function () {
      this.$router.push({ name: 'ProjetoPesquisaResultadosObtidos', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Envia o projeto de pesquisa para registro (chama endpoint para envio).
    enviarProjetoPesquisaParaRegistro: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Enviando projeto de pesquisa para registro...' })
      projetos.postProjetoPesquisaRegistro(this.idProjetoPesquisa)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.$router.go({name: 'ProjetoPesquisaInformacoesBasicas', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Enviando projeto de pesquisa para registro...' })
      })
    }
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-confirm-dialog': ConfirmDialog,
    'c-readonly-field': ReadonlyField
  }
}
</script>

<style scoped>

  .tituloSecao {
    font-size: 1.1em;
    font-weight: bold;
    margin-bottom: 1em;
  }

</style>


// WEBPACK FOOTER //
// contatos.vue?2e40fbb1